const NUMERIC_DOTTED = /^\d+(\.\d+)*$/;

const parseVersion = (version: string | null | undefined) => {
  const trimmed = version?.trim();
  if (!trimmed || !NUMERIC_DOTTED.test(trimmed)) return null;
  return trimmed.split(".").map(Number);
};

export const isOlderHubVersion = (
  current: string | null | undefined,
  latest: string | null | undefined
) => {
  const currentParts = parseVersion(current);
  const latestParts = parseVersion(latest);
  if (!currentParts || !latestParts) return false;

  const length = Math.max(currentParts.length, latestParts.length);
  for (let index = 0; index < length; index++) {
    const difference = (currentParts[index] ?? 0) - (latestParts[index] ?? 0);
    if (difference !== 0) return difference < 0;
  }
  return false;
};
